module.exports = __webpack_public_path__ + "static/media/utp_stp.2371d944.jpg";